function getTrialMockedRows<T extends object>(data: readonly T[], count: number): readonly T[] {
    if (!data.length) {
        return [];
    }

    return Array.from({ length: count }, (_, i) => data[i] ?? data[0]);
}

export default getTrialMockedRows;
